// Generated by `php artisan tracking:generate` from app/Tracking/UserEvent.php. Do not edit.

/** Identifier-valued properties must match this: lower-case words joined by -, _ or :. */
export const IDENTIFIER_PATTERN = /^[a-z0-9]+(?:[-_:][a-z0-9]+)*$/;

export const USER_EVENTS = {
  'artwork.composer_opened': {
    side: 'client',
    fathom: '{entity}:artwork.composer.{trigger}',
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      trigger: { type: 'string', required: true, values: ['prompt', 'settings'] },
    },
  },
  'artwork.created': {
    side: 'fathom_only',
    fathom: '{entity}:artwork.created',
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
    },
  },
  'artwork.failed_prompt_reopened': {
    side: 'client',
    fathom: '{entity}:artwork.failed.reopened.{kind}',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      kind: { type: 'string', required: true, values: ['generate', 'edit'] },
      surface: { type: 'string', required: true, values: ['tile', 'details'] },
      attempt: { type: 'int', required: true, min: 1 },
    },
  },
  'artwork.featured_removed': {
    side: 'client',
    fathom: 'artwork:featured.removed.{origin}',
    subjects: [],
    properties: {
      origin: { type: 'string', required: true, values: ['typed', 'agent'] },
      surface: { type: 'string', required: true, values: ['composer', 'edit'] },
    },
  },
  'artwork.hint_clicked': {
    side: 'client',
    fathom: '{entity}:artwork.hint.{hint}',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      hint: { type: 'string', required: true, maxLength: 40 },
    },
  },
  'artwork.hint_shown': {
    side: 'client',
    fathom: null,
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      hint: { type: 'string', required: true, maxLength: 40 },
    },
  },
  'artwork.prompt_assistant_used': {
    side: 'client',
    fathom: '{entity}:artwork.assistant.{kind}',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      kind: { type: 'string', required: true, values: ['idea_picked', 'rewrite'] },
      surface: { type: 'string', required: true, values: ['composer', 'edit'] },
      ideas: { type: 'int', required: false, min: 0 },
      typed: { type: 'bool', required: false },
    },
  },
  'artwork.prompt_generated': {
    side: 'fathom_only',
    fathom: '{entity}:prompt.generated',
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
    },
  },
  'artwork.tile_action_used': {
    side: 'client',
    fathom: '{entity}:artwork.tile.{action}',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      action: { type: 'string', required: true, values: ['primary', 'edit', 'reference', 'download', 'delete'] },
      surface: { type: 'string', required: false, values: ['tile', 'viewer'] },
    },
  },
  'artwork.tool_used': {
    side: 'client',
    fathom: '{entity}:artwork.{tool}',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      tool: { type: 'string', required: true, values: ['surprise', 'lucky-dip', 'edit'] },
    },
  },
  'artwork.viewer_details_opened': {
    side: 'client',
    fathom: '{entity}:artwork.viewer.details',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
    },
  },
  'artwork.viewer_opened': {
    side: 'client',
    fathom: '{entity}:artwork.viewer.{via}',
    subjects: ['character', 'item', 'location', 'faction', 'campaign', 'document'],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      via: { type: 'string', required: true, values: ['image', 'edit'] },
    },
  },
  'codex.dice_rolled': {
    side: 'fathom_only',
    fathom: 'codex:dice.rolled',
    subjects: [],
    properties: {
    },
  },
  'credits.depleted': {
    side: 'fathom_only',
    fathom: 'credits:depleted',
    subjects: [],
    properties: {
    },
  },
  'credits.viewed': {
    side: 'fathom_only',
    fathom: 'credits:viewed',
    subjects: [],
    properties: {
    },
  },
  'dashboard.tutorial_clicked': {
    side: 'client',
    fathom: 'dashboard:tutorial.{slug}',
    subjects: [],
    properties: {
      slug: { type: 'string', required: true, maxLength: 100 },
    },
  },
  'document.draft_failed': {
    side: 'fathom_only',
    fathom: 'document:draft.failed.{kind}.{reason}',
    subjects: [],
    properties: {
      kind: { type: 'string', required: true, values: ['encounter', 'quest', 'session', 'trap', 'puzzle', 'shop', 'note'] },
      reason: { type: 'string', required: true, values: ['edited', 'provider', 'schema', 'timeout'] },
    },
  },
  'document.drafted': {
    side: 'fathom_only',
    fathom: 'document:drafted.{kind}',
    subjects: [],
    properties: {
      kind: { type: 'string', required: true, values: ['encounter', 'quest', 'session', 'trap', 'puzzle', 'shop', 'note'] },
    },
  },
  'editor.ai_used': {
    side: 'client',
    fathom: 'editor:ai.{action}',
    subjects: [],
    properties: {
      action: { type: 'string', required: true, values: ['command', 'inline_action', 'accepted', 'rejected'] },
    },
  },
  'entity.created_client': {
    side: 'fathom_only',
    fathom: '{entity}:created',
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster'] },
    },
  },
  'entity.creation_mode_chosen': {
    side: 'client',
    fathom: '{entity}:create.{card}',
    subjects: [],
    properties: {
      entity: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'location', 'faction', 'campaign', 'document'] },
      mode: { type: 'string', required: true, values: ['manual', 'wizard', 'steering', 'upload'] },
      card: { type: 'string', required: true, maxLength: 40 },
    },
  },
  'generator.cta_clicked': {
    side: 'fathom_only',
    fathom: 'generator:cta.clicked',
    subjects: [],
    properties: {
    },
  },
  'generator.name_clicked': {
    side: 'fathom_only',
    fathom: 'generator:name.clicked',
    subjects: [],
    properties: {
    },
  },
  'generator.name_description_generated': {
    side: 'fathom_only',
    fathom: 'generator:name.description_generated',
    subjects: [],
    properties: {
    },
  },
  'generator.name_generated': {
    side: 'fathom_only',
    fathom: 'generator:name.generated',
    subjects: [],
    properties: {
    },
  },
  'generator.name_signup_started': {
    side: 'fathom_only',
    fathom: 'generator:name.signup_started',
    subjects: [],
    properties: {
    },
  },
  'item_card.viewed': {
    side: 'client',
    fathom: null,
    subjects: ['item'],
    properties: {
      surface: { type: 'string', required: true, values: ['tab', 'actions_sheet', 'hint', 'fit_bar'] },
      fit: { type: 'string', required: true, values: ['full', 'reduced', 'over'] },
    },
  },
  'map.opened': {
    side: 'client',
    fathom: null,
    subjects: ['location'],
    properties: {
      surface: { type: 'string', required: true, values: ['studio', 'maps_page', 'drill_down', 'direct'] },
    },
  },
  'miniature.downloaded': {
    side: 'client',
    fathom: 'miniature:download.{format}',
    subjects: ['character'],
    properties: {
      format: { type: 'string', required: true, values: ['glb', 'stl'] },
    },
  },
  'miniature.generation_started': {
    side: 'fathom_only',
    fathom: 'miniature:generation.started',
    subjects: [],
    properties: {
    },
  },
  'purchase.cancelled': {
    side: 'fathom_only',
    fathom: 'purchase:cancelled',
    subjects: [],
    properties: {
    },
  },
  'purchase.completed': {
    side: 'fathom_only',
    fathom: 'purchase:completed',
    subjects: [],
    properties: {
      value_cents: { type: 'int', required: true, min: 0 },
    },
  },
  'purchase.initiated': {
    side: 'fathom_only',
    fathom: 'purchase:initiated',
    subjects: [],
    properties: {
      value_cents: { type: 'int', required: true, min: 0 },
    },
  },
  'quick_roll.rolled': {
    side: 'client',
    fathom: 'dashboard:quick-roll.rolled.{type}',
    subjects: [],
    properties: {
      type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'encounter', 'shop'] },
    },
  },
  'quick_roll.type_changed': {
    side: 'client',
    fathom: 'dashboard:quick-roll.type.{type}',
    subjects: [],
    properties: {
      type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'encounter', 'shop'] },
    },
  },
  'quick_roll.used': {
    side: 'client',
    fathom: 'dashboard:quick-roll.used.{type}',
    subjects: [],
    properties: {
      type: { type: 'string', required: true, values: ['character', 'npc', 'monster', 'item', 'encounter', 'shop'] },
      via: { type: 'string', required: false, values: ['tile', 'button'] },
    },
  },
  'showcase.create_cta_clicked': {
    side: 'fathom_only',
    fathom: 'showcase:cta.create',
    subjects: [],
    properties: {
    },
  },
  'steering.rolled': {
    side: 'client',
    fathom: 'steering:rolled.{kind}',
    subjects: [],
    properties: {
      kind: { type: 'string', required: true, values: ['character', 'npc', 'item', 'monster', 'location', 'faction', 'encounter', 'quest', 'session', 'trap', 'puzzle', 'shop'] },
    },
  },
  'user.registered': {
    side: 'fathom_only',
    fathom: 'user:registered',
    subjects: [],
    properties: {
    },
  },
} as const;

export type UserEventName = keyof typeof USER_EVENTS;

/** What each event must be called with. The compiler refuses a missing, unknown or out-of-range property. */
export interface UserEventPayloads {
  'artwork.composer_opened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; trigger: 'prompt' | 'settings' };
  'artwork.created': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document' };
  'artwork.failed_prompt_reopened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; kind: 'generate' | 'edit'; surface: 'tile' | 'details'; attempt: number };
  'artwork.featured_removed': { origin: 'typed' | 'agent'; surface: 'composer' | 'edit' };
  'artwork.hint_clicked': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; hint: string };
  'artwork.hint_shown': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; hint: string };
  'artwork.prompt_assistant_used': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; kind: 'idea_picked' | 'rewrite'; surface: 'composer' | 'edit'; ideas?: number; typed?: boolean };
  'artwork.prompt_generated': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document' };
  'artwork.tile_action_used': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; action: 'primary' | 'edit' | 'reference' | 'download' | 'delete'; surface?: 'tile' | 'viewer' };
  'artwork.tool_used': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; tool: 'surprise' | 'lucky-dip' | 'edit' };
  'artwork.viewer_details_opened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document' };
  'artwork.viewer_opened': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; via: 'image' | 'edit' };
  'codex.dice_rolled': Record<string, never>;
  'credits.depleted': Record<string, never>;
  'credits.viewed': Record<string, never>;
  'dashboard.tutorial_clicked': { slug: string };
  'document.draft_failed': { kind: 'encounter' | 'quest' | 'session' | 'trap' | 'puzzle' | 'shop' | 'note'; reason: 'edited' | 'provider' | 'schema' | 'timeout' };
  'document.drafted': { kind: 'encounter' | 'quest' | 'session' | 'trap' | 'puzzle' | 'shop' | 'note' };
  'editor.ai_used': { action: 'command' | 'inline_action' | 'accepted' | 'rejected' };
  'entity.created_client': { entity: 'character' | 'npc' | 'monster' };
  'entity.creation_mode_chosen': { entity: 'character' | 'npc' | 'monster' | 'item' | 'location' | 'faction' | 'campaign' | 'document'; mode: 'manual' | 'wizard' | 'steering' | 'upload'; card: string };
  'generator.cta_clicked': Record<string, never>;
  'generator.name_clicked': Record<string, never>;
  'generator.name_description_generated': Record<string, never>;
  'generator.name_generated': Record<string, never>;
  'generator.name_signup_started': Record<string, never>;
  'item_card.viewed': { surface: 'tab' | 'actions_sheet' | 'hint' | 'fit_bar'; fit: 'full' | 'reduced' | 'over' };
  'map.opened': { surface: 'studio' | 'maps_page' | 'drill_down' | 'direct' };
  'miniature.downloaded': { format: 'glb' | 'stl' };
  'miniature.generation_started': Record<string, never>;
  'purchase.cancelled': Record<string, never>;
  'purchase.completed': { value_cents: number };
  'purchase.initiated': { value_cents: number };
  'quick_roll.rolled': { type: 'character' | 'npc' | 'monster' | 'item' | 'encounter' | 'shop' };
  'quick_roll.type_changed': { type: 'character' | 'npc' | 'monster' | 'item' | 'encounter' | 'shop' };
  'quick_roll.used': { type: 'character' | 'npc' | 'monster' | 'item' | 'encounter' | 'shop'; via?: 'tile' | 'button' };
  'showcase.create_cta_clicked': Record<string, never>;
  'steering.rolled': { kind: 'character' | 'npc' | 'item' | 'monster' | 'location' | 'faction' | 'encounter' | 'quest' | 'session' | 'trap' | 'puzzle' | 'shop' };
  'user.registered': Record<string, never>;
}
